import Vue from 'vue';
import { mapGetters } from 'vuex';
import SentimentSummary from './SentimentSummary.vue';
import HelpIcon from './HelpIcon.vue';
import Query from 'src/api/query';
import QueryUtils from 'src/utils/query';
export default Vue.extend({
    components: { SentimentSummary, HelpIcon },
    props: {
        query: { type: Object, default: null },
        sentimentData: { type: Object, default: null },
        help: { type: String, default: '<p>A summary of the sentiment scores for verbatims that match this query.</p>' },
        title: { type: String, default: 'Sentiment' }
    },
    data() {
        return {
            calculatedData: {},
            isLoading: false
        };
    },
    computed: {
        ...mapGetters(['hasSentiment', 'currentProject', 'currentAnalysis', 'featureFlags', 'savedQueries']),
        queriedSentimentTypes() {
            if (!this.query) {
                return [];
            }
            let rows = QueryUtils.botanicToQueryRows(this.query);
            let field = rows.find((v) => v.type === 'attribute' && v.field.toLowerCase() === 'sentiment');
            return field ? field.values : [];
        }
    },
    mounted() {
        // Early exit condition
        if (this.hasSentiment === false) {
            return;
        }
        if (this.query) {
            this.isLoading = true;
            Query.drilldown(this.currentProject.id, this.currentAnalysis.id, this.query, 'attributes', 0, this.savedQueries)
                .then((response) => {
                this.calculatedData = {
                    counts: response.counts.sentiment
                };
                this.isLoading = false;
            })
                .catch(() => {
                // Fail quietly
                this.isLoading = false;
            });
        }
        else {
            this.calculatedData = {
                counts: this.$store.getters.currentModel.attribute_info.sentiment.frequencies
            };
        }
    },
    methods: {
        // Bubble up sentiment-clicked event
        bubbleClickEvent(sentimentType) {
            this.$emit('sentiment-clicked', sentimentType);
        }
    }
});
